import React, { Component } from 'react';
import Service from '../../services';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { baseUrlAdmin } from '../../store/apiConstants';
import LoadingComponent from '../loadingComponent';
import { Toast } from 'primereact/toast';
import BranchToSectionDDPreFill from '../BaseDropdownComponents/BranchToSectionDDPreFill';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { exportToExcel } from '../../utils/excelExport';

class StudentSubjectWiseMarksReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            exams: [],
            selectedExam: null,
            filteredData: [],
            rawData: [],
            dataTableKey: 0,
            tableLoading: false,
            dropdownsData: {},
        };
        this.service = new Service();
    }

    getStudentSubjectWiseMarksReport() {
        const { dropdownsData } = this.state;
        this.setState({ tableLoading: true });

        this.service.post(`${baseUrlAdmin}/academicsReports/studentSubjectWiseMarksReport`, {
            academicYear: localStorage.getItem('userAcademicYear'),
            branchId: dropdownsData.branchId,
            sectionId: dropdownsData.sectionId
        }, true)
            .then((response) => {
                if (response.status && response?.res?.status) {
                    // Extract unique exams from the response
                    const exams = response.res.data.map(item => ({
                        examId: item.examId,
                        examName: item.examName
                    })).filter((exam, index, self) =>
                        index === self.findIndex((e) => e.examId === exam.examId)
                    );

                    this.setState({
                        rawData: response.res.data,
                        exams,
                        tableLoading: false,
                        selectedExam: null,
                        filteredData: []
                    });
                } else {
                    this.setState({ tableLoading: false });
                }
            })
            .catch((error) => {
                this.setState({ tableLoading: false });
                this.toast?.show({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Failed to fetch report data',
                    life: 3000
                });
            });
    }

    onExamChange = (selectedExam) => {
        const filteredData = this.state.rawData.filter(item =>
            item.examId === selectedExam.examId
        );
        this.setState({
            selectedExam,
            filteredData,
            dataTableKey: this.state.dataTableKey + 1
        });
    };

    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData
        }, () => {
            if (dropdownsData.branchId && dropdownsData.sectionId) {
                this.getStudentSubjectWiseMarksReport();
            }
        });
    }

    onViewAnalysis = () => {
        const { rawData, selectedExam } = this.state;

        const filteredData = rawData.filter(item =>
            item.examId === selectedExam
        );

        this.setState({ filteredData });
    };

    render() {
        const {
            exams,
            selectedExam,
            filteredData,
            dataTableKey,
            tableLoading
        } = this.state;

        // Transform data for the DataTable
        const transformedData = filteredData.map((item) => {
            // Create base object with student info and overall scores
            let rowData = {
                branchName: item.branchName,
                gradeName: item.gradeName,
                sectionName: item.sectionName,
                enrollmentId: item.enrollmentId,
                studentName: item.studentName,
                totalQuestions: item.totalQuestions,
                studentMarks: item.studentMarks,
                correctCount: item.correctCount,
                incorrectCount: item.incorrectCount,
                notAnsweredCount: item.notAnsweredCount,
                overallPercentage: item.overallPercentage,
                rank: item.rank
            };

            // Add subject data
            item.subjects.forEach(subject => {
                rowData[`${subject.subjectName}_correct`] = subject.correctCount;
                rowData[`${subject.subjectName}_incorrect`] = subject.incorrectCount;
                rowData[`${subject.subjectName}_unattempted`] = subject.notAnsweredCount;
                rowData[`${subject.subjectName}_marks`] = subject.studentMarks;
                rowData[`${subject.subjectName}_percentage`] = subject.percentage;
            });

            return rowData;
        });

        // Get unique subjects from the first record
        const subjects = filteredData.length > 0
            ? filteredData[0].subjects.map(subject => subject.subjectName)
            : [];

        // Add this right after transformedData declaration in render method
        const columns = [
            { field: 'branchName', header: 'Branch' },
            { field: 'gradeName', header: 'Class' },
            { field: 'sectionName', header: 'Section' },
            { field: 'enrollmentId', header: 'Enrollment Code' },
            { field: 'studentName', header: 'Student Name' },
            { field: 'totalQuestions', header: 'No. of Questions' },
            { field: 'studentMarks', header: `Marks (${filteredData[0]?.totalMarks || 0})` },
            { field: 'correctCount', header: 'Total Correct' },
            { field: 'incorrectCount', header: 'Total Incorrect' },
            { field: 'notAnsweredCount', header: 'Total Unattempted' },
            { field: 'overallPercentage', header: 'Total %' },
            { field: 'rank', header: 'Rank' },
            ...subjects.flatMap(subjectName => [
                { field: `${subjectName}_correct`, header: `${subjectName} Correct` },
                { field: `${subjectName}_incorrect`, header: `${subjectName} Incorrect` },
                { field: `${subjectName}_unattempted`, header: `${subjectName} Unattempted` },
                { field: `${subjectName}_marks`, header: `${subjectName} Marks` },
                { field: `${subjectName}_percentage`, header: `${subjectName} %` }
            ])
        ];

        return (
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                padding: '0',
                marginLeft: "100px",
                marginTop: "55px",
                overflow: 'auto',
            }}>
                <div className="card filters-card mt-1 pt-0">
                    <BranchToSectionDDPreFill setValues={this.setDropdownValues} />

                    <div className="grid m-2">
                        <div className="col-3">
                            <label className='label'>Exam <span style={{ color: 'red' }}>*</span></label>
                            <div className="mt-2">
                                <ClassetDropdown
                                    value={selectedExam}
                                    options={exams}
                                    onChange={(e) => this.onExamChange(e.value)}
                                    optionLabel="examName"
                                    optionValue="examId"
                                    placeholder="Select Exam"
                                    disabled={!exams.length}
                                />
                            </div>
                        </div>

                        {/* View Analysis Button */}
                        <div className="col-3 mt-5">
                            <Button
                                label="Download Report"
                                onClick={() => exportToExcel(transformedData, 'Student_Subject_Wise_Marks_Report', columns)}
                                disabled={!filteredData.length}
                                className="p-button-secondary mr-2"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#fff",
                                    color: "#076EFF",
                                    marginRight: "10px"
                                }}
                            />
                            <Button
                                label="View Analysis"
                                onClick={this.onViewAnalysis}
                                disabled={!selectedExam}
                                className="p-button-primary"
                                style={{
                                    width: "137px",
                                    height: "40px",
                                    padding: "10px",
                                    borderRadius: "10px",
                                    border: '1px solid #E6E8EA',
                                    backgroundColor: "#076EFF",
                                    color: "#fff"
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/* DataTable */}
                <div className='datatable-report-demo mx-2'>
                    {filteredData.length > 0 && (
                        <DataTable
                            key={dataTableKey}
                            value={transformedData}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} records"
                            responsiveLayout="scroll"
                            className="p-datatable-custom"
                            loading={tableLoading}
                            loadingIcon="pi pi-spinner"
                            showLoader={false}
                        >
                            {/* Static Columns */}
                            <Column
                                header="S.No"
                                body={(data, options) => options.rowIndex + 1}
                                style={{ width: '70px', textAlign: 'center' }}
                            />
                            <Column field="branchName" header="Branch" style={{ textAlign: 'center' }} />
                            <Column field="gradeName" header="Class" style={{ textAlign: 'center' }} />
                            <Column field="sectionName" header="Section" style={{ textAlign: 'center' }} />
                            <Column field="enrollmentId" header="Enrollment Code" style={{ textAlign: 'center' }} />
                            <Column field="studentName" header="Student Name" style={{ textAlign: 'center' }} />

                            {/* Overall Score Columns */}
                            <Column header="No. of Questions" field="totalQuestions" style={{ textAlign: 'center' }} />
                            <Column
                                header={`Marks (${filteredData[0]?.totalMarks || 0})`}
                                field="studentMarks"
                                style={{ textAlign: 'center' }}
                            />
                            <Column header="Total Correct" field="correctCount" style={{ textAlign: 'center' }} />
                            <Column header="Total Incorrect" field="incorrectCount" style={{ textAlign: 'center' }} />
                            <Column header="Total Unattempted" field="notAnsweredCount" style={{ textAlign: 'center' }} />
                            <Column
                                header="Total %"
                                body={(data) => `${data.overallPercentage}%`}
                                style={{ textAlign: 'center' }}
                            />
                            <Column header="Rank" field="rank" style={{ textAlign: 'center' }} />

                            {/* Subject Columns */}
                            {subjects.flatMap(subjectName => [
                                <Column
                                    key={`${subjectName}_correct`}
                                    field={`${subjectName}_correct`}
                                    header={`${subjectName} Correct`}
                                    style={{ textAlign: 'center' }}
                                />,
                                <Column
                                    key={`${subjectName}_incorrect`}
                                    field={`${subjectName}_incorrect`}
                                    header={`${subjectName} Incorrect`}
                                    style={{ textAlign: 'center' }}
                                />,
                                <Column
                                    key={`${subjectName}_unattempted`}
                                    field={`${subjectName}_unattempted`}
                                    header={`${subjectName} Unattempted`}
                                    style={{ textAlign: 'center' }}
                                />,
                                <Column
                                    key={`${subjectName}_marks`}
                                    field={`${subjectName}_marks`}
                                    header={`${subjectName} Marks`}
                                    style={{ textAlign: 'center' }}
                                />,
                                <Column
                                    key={`${subjectName}_percentage`}
                                    field={`${subjectName}_percentage`}
                                    header={`${subjectName} %`}
                                    body={(data) => `${data[`${subjectName}_percentage`]}%`}
                                    style={{ textAlign: 'center' }}
                                />
                            ])}
                        </DataTable>
                    )}
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </div>
        );
    }
}

export default StudentSubjectWiseMarksReport;